(function () {
  'use strict';
  if (window.RVSFileDrop) return;
  var records = new Map(), bound = new WeakMap(), active = null, queued = false, notice = null, noticeTimer = null, sequence = 0;
  var selector = '[data-rvs-file-drop-zone]';
  var mime = { jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', webp: 'image/webp', gif: 'image/gif', avif: 'image/avif', heic: 'image/heic', mp3: 'audio/mpeg', wav: 'audio/wav', m4a: 'audio/mp4', aac: 'audio/aac', flac: 'audio/flac', aif: 'audio/aiff', aiff: 'audio/aiff', ogg: 'audio/ogg', opus: 'audio/ogg', mp4: 'video/mp4', mov: 'video/quicktime', webm: 'video/webm', zip: 'application/zip' };

  function fileDrag(event) {
    var data = event.dataTransfer;
    return !!data && (Array.from(data.types || []).indexOf('Files') !== -1 || Array.from(data.items || []).some(function (item) { return item.kind === 'file'; }) || !!(data.files && data.files.length));
  }
  function visible(node) {
    return node.isConnected && !node.closest('[hidden], [inert], [aria-hidden="true"]') && !!node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden';
  }
  function surface() {
    return Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]')).filter(visible).pop() || document;
  }
  function typeOf(file) { return (file.type || mime[file.name.split('.').pop().toLowerCase()] || '').toLowerCase().split(';')[0]; }
  function accepts(input, file) {
    var rules = input.accept.toLowerCase().split(',').map(function (rule) { return rule.trim(); }).filter(Boolean);
    var type = typeOf(file), name = file.name.toLowerCase();
    return !rules.length || rules.some(function (rule) { return rule.charAt(0) === '.' ? name.endsWith(rule) : rule.endsWith('/*') ? type.indexOf(rule.slice(0, -1)) === 0 : type === rule; });
  }
  function available(record, area) {
    return visible(record.zone) && area.contains(record.zone) && record.inputs.some(function (input) { return input.isConnected && !input.disabled && !input.closest('[aria-busy="true"]'); });
  }
  function target(event, files) {
    var area = surface(), node = event.target instanceof Element ? event.target.closest(selector) : null;
    var direct = node && records.get(node);
    if (direct && available(direct, area)) return direct;
    var options = Array.from(records.values()).filter(function (record) {
      return available(record, area) && (!files || record.inputs.some(function (input) { return !input.disabled && files.every(function (file) { return accepts(input, file); }); }));
    });
    return options.length === 1 ? options[0] : null;
  }
  function clear() { if (active) active.zone.classList.remove('is-file-dragging'); active = null; }
  function announce(text) {
    if (!notice) { notice = document.createElement('div'); notice.className = 'rvs-file-drop-notice'; notice.setAttribute('role', 'status'); document.body.appendChild(notice); }
    notice.textContent = text; notice.hidden = false;
    clearTimeout(noticeTimer); noticeTimer = setTimeout(function () { notice.hidden = true; }, 4500);
  }
  function feedback(record, text, error) {
    record.status.textContent = text; record.status.hidden = false; record.status.classList.toggle('is-error', !!error);
  }
  function hintFor(input) {
    var accept = input.accept.toLowerCase();
    var kind = /image\//.test(accept) && !/audio\/|video\//.test(accept) ? 'photo' : /audio\//.test(accept) && !/image\/|video\//.test(accept) ? 'audio file' : /video\//.test(accept) && !/image\/|audio\//.test(accept) ? 'video' : 'file';
    return input.multiple ? 'Drop files here, or choose files.' : 'Drop a ' + kind + ' here, or choose a file.';
  }
  function bind(input, zone, options) {
    if (!input || input.type !== 'file' || input.closest('[data-rvs-file-drop-off]')) return;
    var previous = bound.get(input);
    if (previous && records.get(previous.zone) === previous && previous.zone.isConnected && (previous.zone.contains(input) || Array.from(input.labels || []).indexOf(previous.zone) !== -1)) return;
    if (previous) { previous.inputs = previous.inputs.filter(function (other) { return other !== input; }); bound.delete(input); }
    options = options || {};
    zone = zone || input.closest('[data-drop], .rvob__drop, .rvc__edit-photo, .rvc__edit-card-photo, .rvc__shots, .rvs-photo-drop') || input.closest('label') || (input.labels && input.labels[0]);
    var wrapper = false;
    if (!zone) {
      zone = document.createElement('label'); zone.className = 'rvs-file-drop-wrapper'; input.before(zone); zone.appendChild(input); wrapper = true;
      if (input.hidden) { zone.tabIndex = 0; zone.setAttribute('role', 'button'); zone.addEventListener('keydown', function (event) { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); input.click(); } }); }
    }
    var record = records.get(zone);
    if (!record) {
      record = { zone: zone, inputs: [], status: document.createElement('p') };
      zone.setAttribute('data-rvs-file-drop-zone', '');
      if (!zone.title) zone.title = hintFor(input);
      record.status.className = 'rvs-file-drop-status'; record.status.hidden = true; record.status.id = 'rvs-file-drop-status-' + (++sequence); record.status.setAttribute('role', 'status');
      if (options.hint !== false && !zone.matches('[data-drop]')) {
        var hint = document.createElement('small'); hint.className = 'rvs-file-drop-hint'; hint.textContent = hintFor(input); hint.id = 'rvs-file-drop-hint-' + sequence;
        if (wrapper) zone.appendChild(hint); else zone.after(hint);
        input.setAttribute('aria-describedby', [input.getAttribute('aria-describedby'), hint.id, record.status.id].filter(Boolean).join(' '));
        hint.after(record.status);
      } else { zone.after(record.status); input.setAttribute('aria-describedby', [input.getAttribute('aria-describedby'), record.status.id].filter(Boolean).join(' ')); }
      records.set(zone, record);
    }
    record.inputs.push(input); bound.set(input, record);
  }
  function scan() {
    queued = false;
    records.forEach(function (record, zone) { if (!zone.isConnected) { record.status.remove(); records.delete(zone); } });
    document.querySelectorAll('input[type="file"]').forEach(function (input) { bind(input); });
  }
  function schedule() { if (!queued) { queued = true; queueMicrotask(scan); } }
  document.addEventListener('dragover', function (event) {
    if (!fileDrag(event)) return;
    if (event.defaultPrevented) return;
    var record = target(event);
    event.preventDefault();
    if (record !== active) { clear(); active = record; if (active) active.zone.classList.add('is-file-dragging'); }
    if (event.dataTransfer) event.dataTransfer.dropEffect = record ? 'copy' : 'none';
  });
  document.addEventListener('dragleave', function (event) { if (!event.relatedTarget || !document.documentElement.contains(event.relatedTarget)) clear(); });
  document.addEventListener('drop', function (event) {
    if (!fileDrag(event)) return;
    var handled = event.defaultPrevented;
    event.preventDefault(); clear();
    if (handled) return;
    scan();
    var files = Array.from(event.dataTransfer.files || []), record = target(event, files);
    if (!files.length) return announce('Drop a file from your computer onto an upload area.');
    if (!record) return announce('Drop your file onto the matching upload area, or use its Choose file button.');
    var inputs = record.inputs.filter(function (input) { return input.isConnected && !input.disabled; });
    var input = inputs.find(function (candidate) { return files.every(function (file) { return accepts(candidate, file); }); });
    if (!input) return feedback(record, 'That file type is not supported in this upload area. Choose a file using the upload button to see the allowed types.', true);
    if (!input.multiple && files.length > 1) return feedback(record, 'Drop one file at a time in this upload area.', true);
    if (files.some(function (file) { return !file.size; })) return feedback(record, 'One of these files is empty. Choose another file.', true);
    try {
      var transfer = new DataTransfer();
      files.forEach(function (file) { transfer.items.add(!file.type && typeOf(file) ? new File([file], file.name, { type: typeOf(file), lastModified: file.lastModified }) : file); });
      input.files = transfer.files;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (error) { feedback(record, 'Your browser could not add this file. Use the Choose file button instead.', true); }
  });
  window.addEventListener('blur', clear);
  document.addEventListener('change', function (event) { var record = bound.get(event.target); if (record && event.target.files && event.target.files.length) record.status.hidden = true; }, true);
  window.RVSFileDrop = { bind: bind, refresh: scan };
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true }); else scan();
})();
